import React, { useEffect, useState } from 'react';
import TranslateSelector from './TranslateSelector';
import TranslateList from './TranslateList';
import TranslateSetting from './TranslateSetting';
import * as NUMBER from '../../../../common/constants/number';
import * as SIZE from '../../../../common/constants/live/size';
export default function TranslateContainer(props) {
  const [translateLanguage, setTranslateLanguage] = useState(null);
  const [translateTexts, setTranslateTexts] = useState([]);
  const [translateSize, setTranslateSize] = useState(14);
  const [translateSync, setTranslateSync] = useState(-5); // useReduce?

  // static.cloud.sb's.co.kr/player/socket.io.js
  const onChange = (lang, size, sync, texts) => {
    if (lang !== undefined) setTranslateLanguage(lang);
    if (size !== undefined) setTranslateSize(size);
    if (sync !== undefined) setTranslateSync(sync);
    if (texts !== undefined) {
      setTranslateTexts((translateTexts) => [...translateTexts, texts]);
    }
  };

  const onBackFocus = () => {
    props.onBackFocus('translate');
  };

  const onClickPopup = () => {
    window.open(
      `/live/caption/${props.data.data.onair.info.channelid}?gnbYn=N`,
      '온에어 채팅창',
      'width=360px, height=654px, scrollbars=no, location=no, resizable=no, toolbars=no, menubar=no, status=no'
    );
    props.onError();
  };

  const handleKeyDownEvent = (event) => {
    if (
      event.key === 'Tab' &&
      event.target.className === 'translate_serviceinfo_link'
    ) {
      props.onBackFocus('translate');
      event.preventDefault();
    }
  };

  useEffect(() => {
    //console.log('test');
    setTimeout(() => {
      let focusEle =
        document.getElementById('dropdown-module-translate-scroll-down') ||
        document.getElementsByClassName('module_translate_text')[0] ||
        document.getElementById('dropdown-box') ||
        document.getElementById('translate-language-listbox');
      focusEle.focus();
    }, NUMBER.DELAY_MOVE_FOCUS);
  }, [translateLanguage]);

  useEffect(() => {
    try {
      var translateSocket = {};
      // ga('send', 'event', '자막', 'enter');
      translateSocket = io_v2(props.data.apis.translate);
      translateSocket.on('update', function (message) {
        setTimeout(function () {
          if (translateTexts.length > SIZE.LIVE_TRANSLATE_LIMIT_LENG)
            setTranslateTexts([]);
          const receiveData = {
            korean: message.korean,
            english: message.english,
            japanese: message.japanese,
            chinese: message.chinese,
            spanish: message.spanish,
            portuguese: message.portuguese
          };
          onChange(undefined, undefined, undefined, receiveData);
        }, props.sync * 1000);
      });

      translateSocket.on('disconnect', function () {
        if (props.type === 'translate') {
          alert(
            '연결이 끊어졌습니다. 다시 연결해주세요.\n' +
              'The connection is closed, Please reconnect.'
          );
        }
      });

      translateSocket.on('connect', function (message) {});
    } catch (e) {
      console.error(e);
    }

    return () => {
      //console.log('unmout...');
      try {
        if (translateSocket !== undefined) {
          translateSocket.close();
          translateSocket = {};
        }
      } catch (e) {
        console.error(e);
      }
    };
  }, [props.view]);

  return (
    <div
      className={`module_translate_w ${
        translateLanguage !== null
          ? 'translate_select_after'
          : 'translate_select_before'
      }`}
    >
      <div className="module_translate_header">
        <span className="mlch_icon_chat">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="26"
            height="17"
            viewBox="0 0 26 17"
          >
            <g transform="translate(-592.492 -546.637)">
              <path d="M598.681,558.045h0l-4.821-.013.005-10.006h12.426a.654.654,0,1,0,0-1.307H593.861a1.348,1.348,0,0,0-1.369,1.32v9.989a1.35,1.35,0,0,0,1.373,1.324h4.816a.654.654,0,1,0,0-1.307Z"></path>
              <path d="M617.121,550.966H612.3a.654.654,0,1,0,0,1.307l4.82.013,0,10.007H604.043a.654.654,0,1,0,0,1.306h13.081a1.346,1.346,0,0,0,1.368-1.319v-9.99A1.347,1.347,0,0,0,617.121,550.966Z"></path>
              <path d="M610.282,546.726h0a.7.7,0,0,0-.936.235h0l-9.578,15.681a.638.638,0,0,0,.228.9.7.7,0,0,0,.941-.217l.013-.022,9.578-15.682A.639.639,0,0,0,610.282,546.726Z"></path>
              <path d="M599.675,550.351h-1.462a.511.511,0,0,0-.49.347l-1.36,4.247a.486.486,0,0,0,.34.612.517.517,0,0,0,.641-.325l.3-.931h2.609a.5.5,0,0,0,.144-.027l.36.98a.52.52,0,0,0,.655.3.486.486,0,0,0,.313-.626l-1.564-4.247A.511.511,0,0,0,599.675,550.351Zm-1.719,2.97.637-1.99h.719l.732,1.99Z"></path>
              <path d="M608.531,555.355a.491.491,0,1,0,0,.98h1.547l.043.54c-.013.32-.043.98-1.751,1.523a.485.485,0,0,0-.328.617.51.51,0,0,0,.489.337.492.492,0,0,0,.161-.025c1.624-.512,2.4-1.278,2.453-2.466l-.08-1.052a.506.506,0,0,0-.512-.458Z"></path>
              <path d="M612.7,554.492a.5.5,0,0,0-.514.49v4.743a.514.514,0,0,0,1.027,0v-1.819h1.163a.491.491,0,1,0,0-.981h-1.163v-1.943A.5.5,0,0,0,612.7,554.492Z"></path>
            </g>
          </svg>
        </span>
        <strong className="mlch_title">자막 번역</strong>
        {/* {translateLanguage && !props.popup && (<a tabIndex={props.view ? '0' : '-1'} className='mlch_btn_popup' role='button' aria-label='자막 번역 창 팝업으로 띄우기' onClick={onClickPopup}>
            <span className='mlch_icon_popup'>
              <svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'>
                <path
                  d='M641.466,550.775a.445.445,0,0,0-.241-.241.451.451,0,0,0-.169-.034h-7.045a.444.444,0,0,0,0,.889h5.972l-6.353,6.352a.445.445,0,0,0,.629.629l6.352-6.353v5.5a.444.444,0,1,0,.889,0v-6.573A.451.451,0,0,0,641.466,550.775Z'
                  transform='translate(-633.5 -550.5)'
                ></path>
              </svg>
            </span>
            <i className='ir'>자막 번역 창 팝업으로 띄우기</i>
          </a>)} */}
      </div>
      <div
        id="sbsmain-live-tranlate-contents"
        className="module_translate_content"
      >
        {!translateLanguage && (
          <TranslateSelector onClick={onChange} onBackFocus={onBackFocus} />
        )}
        {translateLanguage && (
          <TranslateList
            data={translateTexts}
            language={translateLanguage}
            size={translateSize}
            sync={translateSync}
          />
        )}
        {translateLanguage && (
          <TranslateSetting
            language={translateLanguage}
            size={translateSize}
            sync={translateSync}
            onChange={onChange}
          />
        )}
      </div>
      <div className="translate_serviceinfo_w">
        <span className="translate_serviceinfo_text">translated by Google</span>

        <a
          tabIndex={props.view ? '0' : '-1'}
          target="_blank"
          onKeyDown={handleKeyDownEvent}
          href="https://w3.sbs.co.kr/cs/customerNoticeNew.do?cmd=view&page=1&board_no=17"
          className="translate_serviceinfo_link"
        >
          자막번역서비스안내
        </a>
      </div>
    </div>
  );
}
